import Summary from './Summary';

export default Summary;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/Summary/index.jsx